import { RequestHeaderConfiguration } from '../../../types/ApiClientConfig';
import { SearchAlternativeReponseWithId, SearchResponseDTO } from '../../../types/dls/dls-response/SearchResponseDto';
import { SharedRequestConfiguration, SharedRequestDlsParameter } from '../../../types/GeneralParameter';
import { convertFieldsToStrings } from '../../../util/ConvertPropertiesToString';
import { createFilterCriteriaString, getVansFilterCriteria } from '../../../util/dls/HandleFilterCriteria';
import { getRequestConfiguration } from '../../../util/dls/RequestConfiguration';
import { isCommercialVanBy } from '../../../util/VansConfiguration';
import { GenericFetchClient, ModeSpecificFetchClient } from '../../GenericFetchClient';

/**
 * Available query parameters at dls endpoint /search/alternativeProductSearch only
 */
export type DlsAlternative = SharedRequestDlsParameter & {
  includeFirstVehicles: number;
  filterCriteria: FilterCriteriaAlternative;
};

export type FilterCriteriaAlternative = {
  brand?: string;
  model?: string[];
  modelIdentifier?: string;
  modelDesignation?: string[];
  stockType?: string[];
  bodyType?: string;
  mileage?: string;
  weight?: string[];
  power?: string;
  monthlyRate?: string;
  b2cInstalmentRate?: string;
  b2cFilterPrice?: string;
  b2bInstalmentRate?: string;
  b2bFilterPrice?: string;
  length?: string[];
  fuelType?: string;
  priceValue?: string;
  gearBox?: string[];
  maxLoad?: string;
  loadingSpaceVolume?: string;
  loadingSpaceWidth?: string;
  loadingSpaceHeight?: string;
  driveType?: string[];
  loadingSpaceLength?: string;
  maxWeight?: string;
  numberOfSeatsMultiselect?: string[];
  color_group?: string[];
  newBadges?: string[];
  campaign?: string;
  drive_type?: string[];
  typeClass?: string[];
  equipmentGroup?: string[];
  upholstery_polish?: string[];
  upholstery_group?: string[];
  packages?: string[];
  motorization?: string[];
  modelYear?: string;
  locations?: string[];
  lines?: string;
  generation?: string[];
  firstRegistrationDate?: string;
  color_polish?: string[];
  facelift?: boolean;
  estimatedAvailability?: string[];
  estimatedArrivalDateRange?: string;
  dcpProductType?: string[];
  baumuster4?: string;
};

export class DlsAlternativeClient extends GenericFetchClient implements ModeSpecificFetchClient {
  constructor(config: RequestHeaderConfiguration) {
    super(config);
    this.setPathSegment('/search/alternativeProductSearch');
  }

  getInflateIdLength(): number {
    throw new Error('Method not implemented.');
  }
  setMode(): void {
    throw new Error('Method not implemented.');
  }

  setRequiredParameters({ filterCriteria, ...rest }: DlsAlternative, _: SharedRequestConfiguration): void {
    const additionalRequestConfig = this.getAdditionalRequestConfig({ filterCriteria, ...rest });

    this.setQueryParameters({
      ...convertFieldsToStrings(rest),
      clusteringCriteria: additionalRequestConfig.clusteringCriteria,
      ctx: additionalRequestConfig.ctx,
      vehicleAssortment: additionalRequestConfig.vehicleAssortment,
      filterCriteria: additionalRequestConfig.filters,
    });
  }

  private getAdditionalRequestConfig({ filterCriteria, ...rest }: DlsAlternative) {
    const isVan = !filterCriteria.modelIdentifier ? false : isCommercialVanBy(filterCriteria.modelIdentifier);

    const { clusteringCriteria, vehicleAssortment, ctx } = getRequestConfiguration(isVan, {
      ...rest,
      filterCriteria: filterCriteria,
    });

    return {
      clusteringCriteria: clusteringCriteria?.join(',') ?? '',
      ctx: ctx ?? '',
      vehicleAssortment: rest.vehicleAssortment ?? vehicleAssortment ?? '',
      filters: this.getUpdatedFilterCriteria(isVan, filterCriteria),
    };
  }

  private getUpdatedFilterCriteria(isVan: boolean, filter: FilterCriteriaAlternative): string {
    if (isVan) {
      return getVansFilterCriteria(filter);
    }
    return createFilterCriteriaString(filter);
  }

  checkAllRequiredParametersPresent(): boolean {
    throw new Error('Method not implemented.');
  }

  async getResponse(): Promise<SearchAlternativeReponseWithId> {
    const dlsSearchData = await this.fetchTypedBody<SearchResponseDTO>();
    return {
      responseTypeId: 'SearchResponseDTO',
      ...dlsSearchData,
    };
  }
}
